import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useSelfServiceAbsenceStore = defineStore('selfServiceAbsence', createBaseStore(
    '/selfservice/abmeldungen',
    {
        currentSort: [
            {col: 'endDate', sortDir: 'desc'}
        ]
    }
));
